import { NgModule } from '@angular/core';

import { STORE_FINDER_FEATURE, StoreFinderRootModule } from '@spartacus/storefinder/root';
import { provideConfig } from '@spartacus/core';

@NgModule({
  imports: [
    StoreFinderRootModule
  ],
  providers: [
    provideConfig({
      featureModules: {
        [STORE_FINDER_FEATURE]: {
          module: () => import('@seb/web-common/storefinder/web-common-storefinder.module').then((m) => m.WebCommonStoreFinderModule),
          dependencies: [() => import('@spartacus/storefinder/occ').then((m) => m.StoreFinderOccModule)]
        }
      }
    })
  ]
})
export class StoreFinderFeatureModule {}
